import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { EmptyRow } from '../../EmptyRow';

import style from './style.module.css';

const OneRowTableComponent = ({ rowData, companies }) => (
  <table className={classNames(style.host, 'table table-bordered')}>
    <thead>
      <tr>
        <th># Targets</th>
        <th>{`<= $10`}</th>
        <th>$11 - $25</th>
        <th>$26 - $50</th>
        <th>$51 - $100</th>
        <th>{`>100`}</th>
        <th>Private</th>
        <th>{`Status>4.6`}</th>
      </tr>
    </thead>
    <tbody>
      {companies.length ? (
        <tr>
          <td>{rowData.targets}</td>
          <td>{rowData.lt10}</td>
          <td>{rowData.in1125}</td>
          <td>{rowData.in2650}</td>
          <td>{rowData.in51100}</td>
          <td>{rowData.gt100}</td>
          <td>{rowData.purPri}</td>
          <td>{rowData.statusGt46}</td>
        </tr>
      ) : (
        <tr>
          <EmptyRow colSpan={8} text="No Data To Display" />
        </tr>
      )}
    </tbody>
  </table>
);

OneRowTableComponent.propTypes = {
  companies: PropTypes.instanceOf(Array).isRequired,
  rowData: PropTypes.instanceOf(Object).isRequired,
};

/** One row table component. */
export const OneRowTable = memo(OneRowTableComponent);
